/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    IAny,
    ICreateActionContext,
    IGeneric
} from '@msdyn365-commerce/core';

/**
 * CheckoutModulesStateShare Input Action
 */

export class GetPlantPotsProductCountInput implements IActionInput {
    public getCacheKey = () => `plantPotsProductCount`;
    public getCacheObjectType = () => 'plantPotsProductCount';
    public dataCacheType = (): CacheType => 'request';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetPlantPotsProductCountState {
    potsProductCount?: number; // Share the plantProductsIds accross checkout modules to not check categories again & again
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (inputData: ICreateActionContext<IGeneric<IAny>>): IActionInput => {
    return new GetPlantPotsProductCountInput();
};
/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function sampleStateAction(
    input: GetPlantPotsProductCountInput,
    ctx: IActionContext
): Promise<IGetPlantPotsProductCountState> {
    return { potsProductCount: 0 };
}

/**
 * SampleState - create action
 */
export default createObservableDataAction<IGetPlantPotsProductCountState>({
    action: <IAction<IGetPlantPotsProductCountState>>sampleStateAction,
    input: createInput
});
